'use client';

import { useRouter } from 'next/navigation';
import { Button } from '@sapling/ui/components/ui/button';
import { useCart } from '@/components/ecommerce/cart-provider';
import type { StaticImageData } from 'next/image';

type Props = {
  id: string;
  sku: string;
  name: string;
  price: number; // cents
  maxQuantity?: number;
  image?: string | StaticImageData;
};

export function BookBuyButtons({ id, sku, name, price, image }: Props) {
  const router = useRouter();
  const { addItem, openCart } = useCart();

  const handleAdd = async () => {
    await addItem({ id, sku, name, price, image });
    openCart();
  };

  const handleBuyNow = async () => {
    const cartId = await addItem({ id, sku, name, price, image });
    router.push(`/butik/checkout/${cartId}/review`);
  };

  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      <Button onClick={handleAdd}>Lägg i kundvagn</Button>
      <Button onClick={handleBuyNow} variant="secondary">
        Köp nu
      </Button>
    </div>
  );
}
